import React from 'react';

import { clamp } from '@pkg/utils';

import { HiddenLabel, Spinner, Wrapper } from './SimpleSpinner.style';

export interface SimpleSpinnerProps {
    size?: number;
    ariaLabel?: string;
}

export function SimpleSpinner({ size = 16, ariaLabel = 'Loading…' }: SimpleSpinnerProps) {
    const safeSize = clamp(10, size, 200);

    // TODO: Using `data-spinner` attribute as a selector pattern
    // for other components to leverage.
    return (
        <Wrapper data-spinner="simple" $size={safeSize}>
            <Spinner />
            <HiddenLabel>{ariaLabel}</HiddenLabel>
        </Wrapper>
    );
}
